export default "/_next/static/sounds/phone-breaking-104135bb6b3c63830af32568730d63a6.mp3";